import styled, { css } from 'styled-components';
import { Icon as BPIcon } from '@blueprintjs/core';
export var StyledIcon = styled(BPIcon).withConfig({
  displayName: "Iconstyles__StyledIcon",
  componentId: "sc-kxskov-0"
})(["&&{", "}"], function (props) {
  return css(["width:", "px;height:", "px;"], props.iconSize, props.iconSize);
});